import { render, staticRenderFns } from "./MarkedPayment.vue?vue&type=template&id=36bc20a1&"
import script from "./MarkedPayment.vue?vue&type=script&lang=js&"
export * from "./MarkedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports